/* eslint-disable no-nested-ternary */
import React, { Fragment, useState } from "react";
import "../documentation.css";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { formatTimestamp } from "../helpers";
import { DoneIcon, TodoIcon } from "../../assets/Icons";
import CandImage from "../Components/CandImage";
import Initials from "../Components/Initials";
import pusterlaDocsObj from "./pusterlaDocsObj";
import LoadingSpinner from "../../common/LoadingSpinner";

const Spinner = () => (
  // not the same as the spinner in bookings
  <svg
    width="31"
    height="31"
    style={{ marginLeft: "32px" }}
    viewBox="0 0 38 38"
    stroke="#5e7fcc"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth="2">
        <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

const PusterlaDocuments = ({
  candidates,
  approverEmail,
  getReadingListPdf,
  downloadRef,
  images,
  passImage,
  handleOverlay,
  signDocOff
}) => {
  const [loadingTypeCode, setLoadingTypeCode] = useState("");
  /**
   * Make call to profile 5 to retrieve desired file for Pusterla
   * @param {String} candidate
   * @param {String} typeCode
   * @param {String} filename
   * @param {String} contentType
   * @param {String} fileExt
   */
  const handleDownloadReadingList = async (
    candidate,
    typeCode,
    filename,
    contentType,
    fileExt
  ) => {
    setLoadingTypeCode(typeCode);
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName,
      typeCode,
      filename,
      contentType,
      fileExt
    ).then(() => setLoadingTypeCode(""));
  };
  const [highlightBtn, setHighlightBtn] = useState("");

  const [selected, setSelected] = useState(null);
  const [tempSignedDocs, setTempSignedDocs] = useState({});
  const [tempSignedCount, setTempSignedCount] = useState({});
  const [selectedDocName, setSelectedDocName] = useState();

  console.log("candidates");
  console.log(candidates);

  const setHighligtning = key =>
    highlightBtn === key ? setHighlightBtn("") : setHighlightBtn(key);

  const ViewButton = ({ id, fn, num }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-content-center tw-w-1/2 tw-py-10">
      <button
        className={`${id === highlightBtn &&
          "tw-border-blue-400 tw-text-white tw-bg-blue-400 tw-border-2"} tw-bg-blue-200' tw-bg-blue-100 tw-p-2 lg:tw-w-1/2 tw-w-full tw-rounded-lg ${id !==
          highlightBtn &&
          "hover:tw-bg-blue-200 hover:tw-border-blue-500"} tw-border-blue-300 tw-border-2 tw-cursor-pointer`}
        onClick={fn}
      >
        <span className="md:tw-inline tw-hidden">View</span>
        <span className="md:tw-hidden tw-inline">{num}</span>
      </button>
    </div>
  );

  const setState = i => {
    if (selected === i) {
      setSelected(null);
    } else {
      setSelected(i);
    }
  };

  const DOCS = pusterlaDocsObj;

  const getDocCount = candidate => {
    const values = Object.values(DOCS);

    if (!values) return undefined;
    let readCount = 0;
    let signedCount = 0;

    values.forEach(row => {
      const { id } = row;
      const read =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[id];
      const signed =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[`${id}_SIGNED`];
      if (read) readCount += 1;
      if (signed) signedCount += 1;
    });

    const hasYPUP =
      candidate &&
      candidate.nonReadingListDocs &&
      candidate.nonReadingListDocs.YPUP;
    if (hasYPUP) readCount += 1;
    if (tempSignedCount[candidate.candidateRef])
      signedCount = tempSignedCount[candidate.candidateRef];
    return { readCount, signedCount };
  };

  const Header = ({ title, countObj = { readCount: 0, signedCount: 0 } }) => (
    <div className="tw-w-full tw-flex md:tw-flex-row tw-flex-col md:tw-justify-between tw-items-start md:tw-p-5 tw-p-3">
      <p className="md:tw-pl-2 tw-pl-0 tw-text-md tw-pb-2">{title}</p>
      <div className="tw-w-auto tw-flex md:tw-justify-between tw-mr-2">
        <span className="md:tw-pr-5 tw-pr-3">
          {countObj.signedCount}/2 signed off
        </span>
        <span>{countObj.readCount}/9 documents read </span>
      </div>
    </div>
  );

  const signOffDocNames = [
    "pusterla-pollards-safety-knives.pdf",
    "pusterla-pollards-manual-handling-2022.pdf"
  ];

  const downloadDocNames = [
    "sow-no-29-glue-lines-march-22.pdf",
    "Pusterla Pollards Induction Questionnaire"
  ];

  const DownloadButton = ({ candidate, fileName, typeCode, timestamp }) => (
    <>
      <button
        onClick={() =>
          handleDownloadReadingList(
            candidate,
            typeCode,
            fileName,
            "application/pdf",
            "pdf"
          )
        }
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "14px",
          width: "80%",
          backgroundColor: "white",
          padding: "8px",
          borderRadius: "5px",
          border: "1px solid #2196f3"
        }}
      >
        {loadingTypeCode === typeCode ? <LoadingSpinner /> : "Download"}
      </button>
      {timestamp && (
        <div className="tooltiptext">{formatTimestamp(timestamp)}</div>
      )}
    </>
  );

  const isReadingDownload = docName => downloadDocNames.includes(docName);
  const isInductionQuestionnaire = docName =>
    docName === "Pusterla Pollards Induction Questionnaire";
  const Tooltip = ({ icon, text, id }) => (
    <>
      <div className={`tooltip ${isInductionQuestionnaire(id) && "mb-2"}`}>
        {icon}
        {text && <div className="tooltiptext">{text}</div>}
      </div>
      {!isInductionQuestionnaire(id) && <p className="tw-pt-2">Read</p>}
    </>
  );

  const FileContainer = ({
    docName,
    title,
    read = false,
    signed = false,
    readTimestamp = "",
    signedTimestamp = new Date().toISOString(),
    candidateRef,
    candidate,
    approver = ""
  }) => {
    const checkIfShowSignOff = () => (
      <div className="tooltip">
        <input
          type={"checkbox"}
          className="tw-w-6 tw-h-6 tw-my-1 cursor-pointer"
          onClick={async () => {
            setSelectedDocName(title);
            const success = await signDocOff(docName, candidate.candidateRef);
            if (success) {
              // if profile 5 succesfully signed doc off, store a record temporarily that this doc is signed off and then display the green tick
              setTempSignedDocs({
                ...tempSignedDocs,
                [`${title}`]: candidateRef
              }); // dont store date here store the person
              const copy = tempSignedCount;
              const { signedCount } = getDocCount(candidate);
              copy[candidateRef] = signedCount + 1;
              setTempSignedCount(copy);
            }
            setSelectedDocName("");
          }}
        />
        <div
          className="tooltiptext"
          style={{ textAlign: "left", paddingLeft: "7", width: "auto" }}
          hidden={false}
        >
          {`Sign off '${title}'`}
        </div>
      </div>
    );

    return (
      <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
        <p className="tw-mb-1">{title}</p>
        <div
          className="tw-w-full tw-h-full tw-flex"
          style={{ alignItems: "end" }}
        >
          <div className="tw-flex-1 tw-flex-col tw-py-2">
            {read ? (
              <div className="tooltip">
                <DoneIcon />
                <div className="tooltiptext">
                  Read {formatTimestamp(readTimestamp)}
                </div>
              </div>
            ) : (
              <TodoIcon />
            )}
            <p className=""></p>
            <p className="tw-pt-2">Read</p>
          </div>
          {/* approverEmail */}
          <div className="tw-flex-1 tw-flex-col tw-items-between tw-py-2">
            {tempSignedDocs[`${title}`] &&
            tempSignedDocs[`${title}`] === candidateRef ? ( // handle the temporary version - the person who just aproved will be the email of the person currently logged in
              <div className="tooltip">
                <DoneIcon />
                <div
                  className="tooltiptext"
                  style={{
                    textAlign: "left",
                    paddingLeft: "7",
                    paddingRight: "3",
                    width: "auto"
                  }}
                >
                  Signed {approverEmail ? `by ${approverEmail} ` : ""}{" "}
                  {formatTimestamp(signedTimestamp)}
                </div>
              </div>
            ) : signed ? (
              <div className="tooltip">
                <DoneIcon />
                <div
                  className="tooltiptext"
                  style={{
                    textAlign: "left",
                    paddingLeft: "7",
                    paddingRight: "3",
                    width: "auto"
                  }}
                >
                  Signed {approver ? `by ${approver} ` : ""}{" "}
                  {formatTimestamp(signedTimestamp)}
                </div>
              </div>
            ) : selectedDocName === title ? (
              <Spinner />
            ) : (
              checkIfShowSignOff()
            )}
            <p className=""></p>
            <p className="tw-pt-2">Signed</p>
          </div>
        </div>
      </div>
    );
  };

  const populateDropRow = (candidate, candidateRef) => {
    const values = DOCS;
    if (!values) return undefined;

    const output = values.map((row, i) => {
      const { id, title } = row;
      const read =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[id]; // current person, current line (docs) and current doc - if present they have read the document

      // if(id === '')

      if (!signOffDocNames.includes(id)) {
        // this is for docs that require no sign off
        return (
          <div
            key={id}
            className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center"
          >
            <p className="tw-mb-1">{title}</p>
            <div
              className="tw-w-full tw-h-full tw-flex"
              style={{ alignItems: "end" }}
            >
              <div className="tw-flex-1 tw-flex-col tw-py-2">
                {read ? (
                  isReadingDownload(id) ? (
                    <div className="tooltip mb-2">
                      <DownloadButton
                        candidate={candidate}
                        fileName={title}
                        typeCode={"YPUS"}
                        timestamp={read}
                      />
                    </div>
                  ) : (
                    <Tooltip
                      icon={<DoneIcon />}
                      text={`Read ${formatTimestamp(read)}`}
                      id={id}
                    />
                  )
                ) : (
                  <Tooltip icon={<TodoIcon />} id={id} />
                )}
              </div>
            </div>
          </div>
        );
      }

      const signed =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[`${id}_SIGNED`];

      const approver =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[`${id}_SIGNED_APPROVER`];

      if (signed) {
        return (
          <FileContainer
            key={i}
            docName={id}
            title={title}
            read={read}
            readTimestamp={read}
            signed={true}
            signedTimestamp={signed}
            approver={approver}
            candidateRef={candidateRef}
            candidate={candidate}
          />
        );
      }
      return (
        <FileContainer
          key={i}
          docName={id}
          title={title}
          read={read}
          readTimestamp={read}
          candidateRef={candidate.candidateRef}
          candidate={candidate}
        />
      );
    });

    const hasYPUP =
      candidate &&
      candidate.nonReadingListDocs &&
      candidate.nonReadingListDocs.YPUP;

    output.unshift(
      <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
        <p className="tw-mb-1">Pusterla Pollards Induction Questionnaire</p>
        <div
          className="tw-w-full tw-h-full tw-flex"
          style={{ alignItems: "end" }}
        >
          <div className="tw-flex-1 tw-flex-col tw-py-2">
            {hasYPUP ? (
              <div className="tooltip mb-2">
                <DownloadButton
                  candidate={candidate}
                  fileName={"Pusterla Pollards Induction Questionnaire"}
                  typeCode={"YPUP"}
                />
              </div>
            ) : (
              <Tooltip
                icon={<TodoIcon />}
                id={"Pusterla Pollards Induction Questionnaire"}
              />
            )}
          </div>
        </div>
      </div>
    );

    return output;
  };

  // TODO - when free make the below into a seperate folder with these functions for RTW so its not duplicated in Bells, Pecan and in pusterla [dk] - [08/06/2022]

  /**
   *  Mapping of file typecode to file ext
   */
  const typeCodeToExt = new Map();
  typeCodeToExt
    .set("YPDC", ".pdf") // Contract for services, .pdf
    .set("YREU", ".pdf") // Settled Status - EU Settlement Scheme , .pdf (does not come from Profile5 - added by consultant direct to candidates profile)
    .set("YREP", ".pdf") // Pre-Settled Status - EU Settlement Scheme, .pdf (does not come from Profile5 - added by consultant direct to candidates profile)
    .set("JPPT", ".jpg") // Front of passport for RTW, .jpg
    .set("JPVI", ".jpg") // Visa front for RTW, .jpg
    .set("JPVB", ".jpg") // Visa back for RTW, .jpg
    .set("JPID", ".jpg") // Front of ID for RTW, .jpg
    .set("JPPB", ".jpg") // back of ID for RTW, .jpg
    .set("JBIR", ".jpg") // birth certficate, .jpg
    .set("JPNI", ".jpg") // Back of passport for RTW, .jpg
    .set("WRTV", ".docx") // Verfiication RTW, .docx
    .set("YXP", ".pdf") // Share Code Check Perm, .pdf
    .set("YXT", ".pdf") // Share Code Check Temp, .pdf
    .set("YRTW", ".pdf"); // Right to Work Approved, .pdf

  /**
   *  File types requested by Pecan Deluxe.
   */
  const RTW_TYPE_CODES = [
    "YPDC", // Contract for services, .pdf
    "YREU", // Settled Status - EU Settlement Scheme
    "YREP", // Pre-Settled Status - EU Settlement Scheme
    "JPPT", // Front of passport for RTW, .jpg
    "JPVI", // Visa front for RTW, .jpg
    "JPVB", // Visa back for RTW, .jpg
    "JPID", // Front of ID for RTW, .jpg
    "JPPB", // back of ID for RTW, .jpg
    "JBIR", // birth certficate, .jpg
    "JPNI", // Back of passport for RTW, .jpg
    "WRTV", // Verfiication RTW, .docx
    "YXP", // Share Code Check Perm, .pdf
    "YXT", // Share Code Check Temp, .pdf
    "YRTW" // Right to Work Approved, .pdf
  ];

  /**
   * Retrieves only RTW files from candidate files.
   * @param {Object} candidate
   * @returns {Array<Array<string, string>} Array of Array [[typecode, title], [...]]
   */
  const candidateHasRTWDocs = candidate => {
    let rtwOnly = [];
    if (candidate && candidate.rtwDocs) {
      const entries = Object.entries(candidate.rtwDocs);
      rtwOnly = entries.filter(row => {
        const [typeCode] = row;
        return RTW_TYPE_CODES.includes(typeCode);
      });
    }
    return rtwOnly;
  };

  /**
   * Return the correct content type for file
   * @param {String} ext
   * @returns {String}
   */
  const getContentType = ext => {
    if (ext === ".docx")
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (ext === ".pdf") return "application/pdf";
    return "image/jpg";
  };

  /**
   * Remove any illegal character(s) (e.g. -) which can prevent downloads when downloading files to a users computer
   */
  const cleanFilename = filename => filename.replace(/\W+/g, " ");

  /**
   * Return the dropdown of candidate RTW files (if) avaliable for download or red cross icon.
   * @param {Object} candidate
   * @returns JSX
   */
  const RTWDocs = candidate => {
    const rtwDocs = candidateHasRTWDocs(candidate);
    if (rtwDocs.length > 0) {
      return (
        <div className="tw-w-full tw-flex tw-justify-center">
          <Menu
            style={{ width: "100%" }}
            as="div"
            className="tw-relative tw-inline-block sm:tw-pl-2 tw-text-left"
          >
            <Menu.Button
              style={{ border: "1px solid #2196f3" }}
              className="tw-flex tw-justify-center tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-p-2 tw-bg-white tw-text-sm tw-text-gray-700 "
            >
              RTW Downloads
              <ChevronDownIcon
                className="tw--mr-1 tw-ml-2 tw-h-5 tw-w-5"
                aria-hidden="true"
              />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="tw-transition tw-ease-out tw-duration-100"
              enterFrom="tw-transform tw-opacity-0 tw-scale-95"
              enterTo="tw-transform tw-opacity-100 tw-scale-100"
              leave="tw-transition tw-ease-in tw-duration-75"
              leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
              leaveTo="tw-transform tw-opacity-0 tw-scale-95"
            >
              <Menu.Items className=" tw-origin-top-right tw-relative tw-w-full tw-right-0 tw-mt-2 tw-w-36 tw-rounded-md tw-shadow-lg tw-bg-white tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-focus:outline-none">
                <div className="tw-py-1">
                  {rtwDocs.map(row => {
                    const [typeCode, title] = row;
                    const ext = typeCodeToExt.get(typeCode);
                    return (
                      <Menu.Item key={typeCode}>
                        {({ active }) => (
                          <div
                            // Set correct file ext + MIME type for RTW content
                            onClick={() =>
                              handleDownloadReadingList(
                                candidate,
                                typeCode,
                                cleanFilename(title),
                                getContentType(ext),
                                ext
                              )
                            }
                            href="#"
                            className={`${
                              active
                                ? "tw-bg-gray-100 tw-text-gray-900 tw-no-underline"
                                : "tw-no-underline tw-text-gray-700"
                            }
                              tw-block tw-px-4 tw-py-2 tw-text-sm tw-no-underline tw-cursor-pointer `}
                          >
                            {title}
                          </div>
                        )}
                      </Menu.Item>
                    );
                  })}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      );
    }
    return (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );
  };

  return (
    <div>
      <div className="tw-rounded-md tw-overflow-x-auto ">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 ">
            <table className="tw-overflow-x tw-border-collapse tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-border-collapse tw-bg-gray-50 tw-rounded-md tw-border-0 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "25%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Worker
                  </th>
                  <th
                    scope="col"
                    style={{ width: "50%" }}
                    className="tw-w-full tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Documents
                  </th>
                  <th
                    scope="col"
                    style={{ width: "25%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Right to Work Documents
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <Fragment key={i}>
                    <tr className="reading-list__rows" key={i * 100}>
                      <td className="tw-text-sm">
                        <div className="tw-flex lg:tw-flex-row tw-flex-col tw-w-full lg:tw-items-center md:tw-text-left tw-text-center">
                          {images && images[c.candidateRef] ? (
                            <CandImage
                              handleOverlay={handleOverlay}
                              passImage={passImage}
                              image={images[c.candidateRef]}
                              firstName={c.firstName}
                            />
                          ) : (
                            <Initials
                              firstName={c.firstName}
                              lastName={c.lastName}
                            />
                          )}
                          <p className="tw-font-bold tw-font-lg lg:tw-pl-0 tw-pl-1">
                            {c.firstName} {c.lastName}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          className={`tw-flex tw-min-h-full tw-justify-center`}
                        >
                          <ViewButton
                            id={`${i}${c.lastName}L1`}
                            fn={() => {
                              setState(i, "line1");
                              setHighligtning(`${i}${c.lastName}L1`);
                            }}
                            num="L1"
                          />
                        </div>
                      </td>
                      <td className="tw-p-10">{RTWDocs(c)}</td>
                    </tr>

                    {selected === i ? (
                      <tr>
                        <td colSpan="6">
                          <Header
                            title={`Documents - ${c.firstName} ${c.lastName}`}
                            countObj={getDocCount(c)} // individual candidate
                          />
                          <div className="tw-flex tw-min-w-full tw-overflow-y-auto tw-flex-wrap tw-pb-4 tw-px-0 tw-justify-center tw-items-center">
                            {/* TODO Pass here all the sops the person has using timestamp to show what is read + signed */}
                            {populateDropRow(c)}
                          </div>
                        </td>
                      </tr>
                    ) : null}
                  </Fragment>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PusterlaDocuments;
